import React from 'react';
import styled from 'styled-components';
import { AppLayout } from '../../components/layout';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.6;
  color: #2d3748;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a365d;
  margin-bottom: 24px;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  color: #2c5282;
  margin-bottom: 16px;
`;

export const PrivacyPolicy = () => {
  return (
    <AppLayout>
      <Container>
        <Title>Privacy Policy</Title>
        <p>Last Updated: January 12, 2026</p>
        
        <Section>
          <SubTitle>1. Introduction</SubTitle>
          <p>Welcome to ERP Mock. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
        </Section>

        <Section>
          <SubTitle>2. The Data We Collect</SubTitle>
          <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
          <ul>
            <li>Identity Data: includes first name, last name, username or similar identifier.</li>
            <li>Contact Data: includes email address and telephone numbers.</li>
            <li>Technical Data: includes internet protocol (IP) address, your login data, browser type and version.</li>
          </ul>
        </Section>

        <Section>
          <SubTitle>3. How We Use Your Data</SubTitle>
          <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
          <ul>
            <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
            <li>Where it is necessary for our legitimate interests.</li>
            <li>Where we need to comply with a legal obligation.</li>
          </ul>
        </Section>

        <Section>
          <SubTitle>4. Data Security</SubTitle>
          <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.</p>
        </Section>

        <Section>
          <SubTitle>5. Contact Us</SubTitle>
          <p>If you have any questions about this privacy policy or our privacy practices, please contact us at: devbob.co@gmail.com</p>
        </Section>
      </Container>
    </AppLayout>
  );
};
